import baseRequest from "./baseReuqest";

export function getBxLinkFunnels() {
    return baseRequest(`/api/call-center/bxlink-funnels`);
}

export function getBxLinkFunnelStages(funnelId) {
    return baseRequest(`/api/call-center/bxlink-funnel-stages/${funnelId}`);
}
